import { render, staticRenderFns } from "./EditContractStrategicImportance.vue?vue&type=template&id=5197a79e&"
import script from "./EditContractStrategicImportance.vue?vue&type=script&lang=js&"
export * from "./EditContractStrategicImportance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports